import { Brand } from 'utility-types';

import { PoolID } from '../bridge-settings/sections/types/PoolID';
import { ISO8601FormattedString } from './ISO8601FormattedString';

export interface ISiteBridgeSettingsForSiteAdmin {
    siteId: string;
    siteAdminSettings: ISiteAdminBridgeSettings;
}

export interface ISiteAdminBridgeSettings {
    remoteQueryingEnabled: boolean;
    remoteAgentSettings?: IRemoteAgentSiteSettings;
}

export interface IRemoteAgentSiteSettings {
    agents?: IRemoteQueryAgent[];
    notificationForClientNotRunningEnabled?: boolean;
}

export type AgentID = Brand<string, 'AgentID'>;

export interface IRemoteQueryAgent {
    id: AgentID;
    agentName: string;
    ownerId: string;
    ownerFriendlyName: string;
    deviceId: string;
    connectionStatus: RemoteAgentConnectionStatus;
    lastUsed: ISO8601FormattedString;
    pooled: boolean;
    poolId: PoolID;
    version: string | undefined;
    needsUpgrade: boolean | undefined;
}

export enum RemoteAgentConnectionStatus {
	CONNECTED = 'CONNECTED',
	DISCONNECTED = 'DISCONNECTED',
	UNKNOWN = 'UNKNOWN',
	NEEDS_UPGRADE = 'NEEDS_UPGRADE',
	NOT_IN_SERVICE_MODE = 'NOT_IN_SERVICE_MODE',
	NOT_RESPONSIVE = 'NOT_RESPONSIVE',
	THROTTLED = 'THROTTLED',
}
